import { secretStorage } from "config"
import { setRolesInAxiosHeader } from "config/axiosConfig";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { app } from "router/routes";
import { actions } from "store";
import { application } from "store/hooks";

const useSelectRole = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { roleIndex } = useSelector(state => state.user)
    const user_data = secretStorage.getItem("user")?.user_data
    const roleOptions = user_data?.map(({ id, role_id, role_label, user_roles }) => ({
        user_roles: user_roles,
        name: role_label
    }));

    const setRoleIndex = application.useRoleIndex()

    const selectRole = useCallback((roleOption) => {
        navigate(app.dashboard)
        const roleIndex = roleOptions.findIndex((role) => role.user_roles === roleOption.user_roles)
        if (roleIndex === -1) return
        setRoleIndex(roleIndex)
        dispatch(actions.setDefaultRole(roleOption))
    }, [])

    return selectRole
}

export default useSelectRole

